module.exports = __webpack_public_path__ + "assets/img/28918.png?4946a8032105e595b92db12af63aa083";